
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./plasmaswap-sdk.cjs.production.min.js')
} else {
  module.exports = require('./plasmaswap-sdk.cjs.development.js')
}
